import type { ISystem, ISystemGroup } from '../types';
import { isGroup } from './isGroup';

export const getGroupsFromChildGroups = (gs: ISystemGroup | ISystem): ISystemGroup[] => {
  if (!isGroup(gs) || !gs.childGroups) return [];

  const result = gs.childGroups.filter(isGroup);
  return result;
};
